// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import adminMenuItems from 'menu-items-admin';


// ==============================|| SIDEBAR ADMIN MENU LIST ||============================== //

const AdminMenuList = () => {
    const navItems = adminMenuItems.items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default AdminMenuList;
